import { pickThemeColor } from '@/theme';
import styled from 'styled-components';

export const StyledPictures = styled.div`
  padding: 1.5rem;

  &:first-of-type {
    margin-top: 0.25rem;
  }

  &:last-of-type {
    margin-bottom: 0.25rem;
  }

  &:nth-child(even) {
    border-block: 1px solid ${pickThemeColor('LIGHT_PURPLE')};
    background-color: ${pickThemeColor('BG_SECONDARY')};
  }
`;
